import { render, staticRenderFns } from "./About_FQR.vue?vue&type=template&id=5fc18cf2&scoped=true&"
import script from "./About_FQR.vue?vue&type=script&lang=js&"
export * from "./About_FQR.vue?vue&type=script&lang=js&"
import style0 from "./About_FQR.vue?vue&type=style&index=0&id=5fc18cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc18cf2",
  null
  
)

export default component.exports